export const RETRIGGER_REASON_SOURCE = 'Tickets UI Retrigger Verification button'

const encodeUtf8ForBase64 = (value) =>
  encodeURIComponent(value).replace(/%([0-9A-F]{2})/g, (_, hex) => String.fromCharCode(Number.parseInt(hex, 16)))

const decodeUtf8FromBase64 = (value) => {
  const percentEncoded = Array.from(value, (char) =>
    `%${char.charCodeAt(0).toString(16).padStart(2, '0')}`,
  ).join('')
  return decodeURIComponent(percentEncoded)
}

export const encodeToolArguments = (args) => {
  const json = JSON.stringify(args)
  return btoa(encodeUtf8ForBase64(json))
}

export const decodeToolArguments = (encodedArgs) => {
  if (!encodedArgs) {
    return []
  }
  const base64Args = encodedArgs.includes('%') ? decodeURIComponent(encodedArgs) : encodedArgs
  const binary = atob(base64Args)

  try {
    return JSON.parse(decodeUtf8FromBase64(binary))
  } catch {
    return JSON.parse(binary)
  }
}

export const createRetriggerReason = ({ triggeredBy } = {}) =>
  `${RETRIGGER_REASON_SOURCE}; triggeredBy=${triggeredBy || 'unknown'}`

export const createResubmitUrl = ({ orderId, itemIndex, triggeredBy }) => {
  const argObject = [
    { name: 'orderId', value: { type: 'string', value: orderId } },
    { name: 'itemIndex', value: { type: 'number', value: itemIndex } },
    { name: 'reason', value: { type: 'string', value: createRetriggerReason({ triggeredBy }) } },
  ]
  const encodedArgs = encodeURIComponent(encodeToolArguments(argObject))
  return `/tools?tool=forceReprocessItem&arguments=${encodedArgs}`
}
